import React, { useState } from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { TextField } from '@material-ui/core';
import { Link } from 'react-router-dom';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { firebase } from '../firebase/firebaseConfig';


export const LoginPage = () => {

    

    const [loginForm, setloginForm] = useState({
        email: '',
        password: ''
    });

    const handleLogin = async(e) => {
        e.preventDefault();
        try {
            await firebase.auth().signInWithEmailAndPassword(loginForm.email, loginForm.password);
            console.log("Inicio de sesión exitoso");
          } catch (error) {
            console.log("Error de inicio de sesión:", error.message);
          }    };

    return (
        <div className="row justify-content-center align-items-center w-100 m-0" style={{ height:'inherit' }}>
            <div className="col-12 col-sm-8 col-md-4 col-lg-3">
                <Card  variant="outlined">
                    <form onSubmit={handleLogin}>
                        <CardContent className="text-center">
                            <Typography 
                                variant="h5" 
                                className="my-3"
                                gutterBottom
                            >
                                Iniciar Sesión
                            </Typography>
                            <TextField 
                                variant="outlined"
                                size="small"
                                label="correo"
                                value={loginForm.email}
                                onChange={e => setloginForm({
                                    ...loginForm,
                                    email: e.target.value
                                })}
                                className="mb-3"
                                fullWidth
                            />
                            <TextField 
                                variant="outlined"
                                size="small"
                                type="password"
                                label="contraseña"
                                onChange={e => setloginForm({
                                    ...loginForm,
                                    password: e.target.value
                                })}
                                value={loginForm.password}
                                className="mb-3"
                                fullWidth
                            />
                            <div className="d-flex justify-content-end">
                                <Typography>
                                    <Link href="#">
                                        ¿Olvidaste tu contraseña?
                                    </Link>
                                </Typography>
                            </div>
                        </CardContent>
                        <CardActions style={{display: 'flex', flexDirection: 'column'}}>
                            <Button 
                                type="submit"
                                variant="contained"
                                color="primary"
                                disabled={loginForm.email && loginForm.password ? false : true}
                                style={{ margin: '0.8em 0' }}
                                fullWidth
                                startIcon={<ArrowForwardIosIcon/>}
                            >
                                Iniciar sesión
                            </Button>
                        </CardActions>
                    </form>
                </Card>
            </div>
        </div>
    );
}


